import Form from "react-jsonschema-form";

import { isObject, mergeObjects } from "react-jsonschema-form/lib/utils";
import { toErrorList } from "react-jsonschema-form/lib/validate";
import toPath from "lodash.topath";

function unwrapErrorHandler(errorHandler) {
    return Object.keys(errorHandler).reduce((acc, key) => {
        if (key === "addError") {
            return acc;
        } else if (key === "__errors") {
            return { ...acc, [key]: errorHandler[key] };
        }
        return { ...acc, [key]: unwrapErrorHandler(errorHandler[key]) };
    }, {});
}

function toErrorSchema(errors) {
    if (!errors.length) {
        return {};
    }
    return errors.reduce((errorSchema, error) => {
        const { property, message } = error;
        const path = toPath(property);
        let parent = errorSchema;
        for (const segment of path.slice(1)) {
            if (!(segment in parent)) {
                parent[segment] = {};
            }
            parent = parent[segment];
        }
        if (Array.isArray(parent.__errors)) {
            // We store the list of errors for this node in a property named __errors
            // to avoid name collision with a possible sub schema field named
            // "errors" (see `validate.createErrorHandler`).
            parent.__errors = parent.__errors.concat(message);
        } else {
            parent.__errors = [message];
        }
        return errorSchema;
    }, {});
}

function createErrorHandler(formData) {
    const handler = {
        __errors: [],
        addError(message) {
            this.__errors.push(message);
        },
    };
    if (isObject(formData)) {
        return Object.keys(formData).reduce((acc, key) => {
            return { ...acc, [key]: createErrorHandler(formData[key]) };
        }, handler);
    }
    if (Array.isArray(formData)) {
        return formData.reduce((acc, value, key) => {
            return { ...acc, [key]: createErrorHandler(value) };
        }, handler);
    }
    return handler;
}

export default class CWForm extends Form {
    validate(formData, schema) {
        const errorSchema = toErrorSchema([]);
        const errorHandler = this.props.validate(formData, createErrorHandler(formData));
        const userErrorSchema = unwrapErrorHandler(errorHandler);
        const newErrorSchema = mergeObjects(errorSchema, userErrorSchema, true);
        const newErrors = toErrorList(newErrorSchema);

        return { errors: newErrors, errorSchema: newErrorSchema };
    }
}


// WEBPACK FOOTER //
// ./src/components/forms/CWForm.js